<template>
  <div>
    <section class="is-fluid">
      <BookmarkCard
        :card-type="defaultView"
        :bookmarks="bookmarks"
        :selected-tags="selectedTags"
        @tagClicked="addTag"
        @viewerChanged="viewerChanged"
        @edited="bookmarkChanged"
      />

      <infinite-loading
        v-if="bookmarks.length >= 10"
        ref="infiniteLoading"
        @infinite="infiniteHandler"
      />
    </section>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import { showMixin } from '@/mixins/crud/pagination'
  import BookmarkCard from '@/components/bookmarks/BookmarkCard.vue'

  export default {
    name: 'BookmarksList',
    components: {
      BookmarkCard,
    },
    mixins: [ showMixin('bookmark') ],
    props: {
      selectedTagsParams: {
        type: Array,
        default: function () {
          return [];
        }
      },
      singleTag: {
        type: String,
        default: null
      },
    },
    data: function() {
      return {
        page: 2,
        allowNew: true,
        viewerOn: false
      }
    },
    computed: {
      ...mapGetters({
        bookmarks: 'bookmarks/all',
        tags: 'tags/all',
      }),
      ...mapState({
        defaultView: state => state.defaultView,
      }),
      selectedTags() {
        return this.singleTag ? [this.singleTag] : this.$store.state.selectedTags
      },
      allTagsNames() {
        return this.tags.map(tag => tag.name)
      },
    },
    watch: {
      "$route.params.selectedTagsParams"() {
        this.parseParams()
      },
      selectedTags() {
        this.updateList()

        if (this.$refs.infiniteLoading) {
          this.$refs.infiniteLoading.$emit('reset', this.$refs.infiniteLoading.stateChanger)
        }
      }
    },
    mounted() {
      let vm = this
      this.parseParams()
      this.loadFilteredBookmarks({filter: this.selectedTags}).then(() => {
        vm.allowNew = false
      })
    },
    methods: {
      ...mapActions({
        loadFilteredBookmarks: 'bookmarks/loadPageWithAllTags',
        appendPage: 'bookmarks/appendPage'
      }),
      addTag(tag) {
        let selectedTags = Array.from(this.selectedTags)
        if (Array.isArray(tag)) {
          this.setSelectedTags(tag)
        } else {
          if (!selectedTags.includes(tag)) {
            selectedTags.push(tag)
            this.setSelectedTags(selectedTags)
          } else {
            const index = selectedTags.indexOf(tag);
            selectedTags.splice(index, 1)
            this.setSelectedTags(selectedTags)
          }
        }
      },
      clearAllTags() {
        this.setSelectedTags([])
      },
      setSelectedTags(value) {
        this.$store.commit('setSelectedTags', value)
      },
      parseParams() {
        const params = this.$route.params.selectedTagsParams
        if (params) {
          if (typeof params === 'string') {
            this.$store.commit('setSelectedTags', this.$route.params.selectedTagsParams.split('/'))
          } else {
            this.$store.commit('setSelectedTags', params)
          }
        } else if (this.selectedTags.length > 0 ) {
          this.$store.commit('setSelectedTags', [])
        }
      },
      updateList() {

        if(!this.singleTag){
          if (this.selectedTags.length == 0) {
            this.$router.push({name: 'BookmarkList'})
          } else {
            this.$router.push({name: 'BookmarkListFiltered', params: {selectedTagsParams: this.selectedTags}})
          }
        }
        
        this.loadFilteredBookmarks({filter: this.selectedTags})
      },
      viewerChanged(viewer) {
        this.viewerOn = viewer
      },
      bookmarkChanged(eventArgs){
        this.$emit('bookmarkChanged', eventArgs);
      },
      infiniteHandler($state) {
        this.appendPage({page: this.page, filter: this.selectedTags})
            .then((response) => {
              if (response.data?.bookmarks?.collection?.length) {
                this.page += 1;
                $state.loaded();
              } else {
                $state.complete();
              }
            })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .favicon {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    margin-right: 4px;
  }
</style>
